/**
 * Forces a reflow, allows transitions update
 * between exited -> entering. <CSSTransition />
 * does this automatically, but this function
 * needs to be run onEnter when using <Transition />
 */

const forceReflow = (node: Element): number => node && node.scrollTop;

export default forceReflow;
